import { Package, MapPin } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface KPICardsProps {
  totalOrders: number;
  processedOrders: number;
  locationOrdersCount: number;
  onOrdersClick: () => void;
  onLocationOrdersClick: () => void;
}

export const KPICards: React.FC<KPICardsProps> = ({
  totalOrders,
  processedOrders,
  locationOrdersCount,
  onOrdersClick,
  onLocationOrdersClick,
}) => {
  const { t } = useTranslation('reusedModule');
  return (
    <div className="grid grid-cols-2 gap-4 mb-4">
      {/* KPI 1: Pedidos Procesados */}
      <button
        onClick={onOrdersClick}
        className="bg-background border border-border rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all text-left"
      >
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">{t('summary.processed_orders', 'Pedidos Procesados')}</span>
          <Package className="w-4 h-4 text-primary" />
        </div>
        <div className="flex items-baseline gap-1">
          <span className="text-2xl font-bold text-foreground">{processedOrders}</span>
          <span className="text-sm text-muted-foreground">/ {totalOrders}</span>
        </div>
        <div className="mt-2 h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-all duration-300"
            style={{
              width: `${totalOrders > 0 ? (processedOrders / totalOrders) * 100 : 0}%`,
            }}
          />
        </div>
      </button>

      {/* KPI 2: Órdenes de Ubicación */}
      <button
        onClick={onLocationOrdersClick}
        className="bg-background border border-border rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all text-left"
      >
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">{t('summary.location_orders', 'Órdenes de Ubicación')}</span>
          <MapPin className="w-4 h-4 text-primary" />
        </div>
        <div className="flex items-baseline gap-1">
          <span className="text-2xl font-bold text-foreground">{locationOrdersCount}</span>
          <span className="text-sm text-muted-foreground">{t('summary.created', 'creadas')}</span>
        </div>
      </button>
    </div>
  );
};
